"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { ICinema } from "src/lib/types/ICinema";
import Biograf from "src/components/biografer/Biograf";
import styles from "./CinemaList.module.css";
import SearchSvg from "src/components/svg/SearchSvg";
import RightArrowSvg from "src/components/svg/RightArrowSvg";
export type CinemaListItem = Pick<ICinema, "_id" | "title" | "slug" | "imageV2"> & {
  contactText?: string;
};

//const INITIAL_COUNT = 9;
const INITIAL_COUNT = 1000; // Show all cinemas at once

function matchesSearch(cinema: CinemaListItem, query: string) {
  const q = query.toLowerCase();
  if (cinema.title.toLowerCase().includes(q)) return true;
  if (cinema.contactText?.toLowerCase().includes(q)) return true;
  return false;
}
export default function CinemaList(t0) {
  const $ = _c(29);
  const {
    cinemas
  } = t0;
  const [query, setQuery] = useState("");
  const [expanded, setExpanded] = useState(false);
  let t1;
  if ($[0] !== cinemas || $[1] !== query) {
    t1 = query.trim() ? cinemas.filter(c => matchesSearch(c, query.trim())) : cinemas;
    $[0] = cinemas;
    $[1] = query;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const filtered = t1;
  let t2;
  if ($[3] !== query) {
    t2 = query.trim();
    $[3] = query;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const isSearching = t2.length > 0;
  let t3;
  if ($[5] !== expanded || $[6] !== filtered || $[7] !== isSearching) {
    t3 = isSearching || expanded ? filtered : filtered.slice(0, INITIAL_COUNT);
    $[5] = expanded;
    $[6] = filtered;
    $[7] = isSearching;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const visible = t3;
  const hasMore = !isSearching && filtered.length > INITIAL_COUNT && !expanded;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e => setQuery(e.target.value);
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== query) {
    t5 = <input type="text" placeholder={"S\xF8g efter postnummer, by eller navn p\xE5 biograf"} className={styles.searchInput} value={query} onChange={t4} />;
    $[10] = query;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <button className={styles.searchButton} aria-label={"S\xF8k"}><SearchSvg /></button>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5) {
    t7 = <div className={styles.searchWrapper}>{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== visible) {
    t8 = visible.map(_temp);
    $[15] = visible;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== query || $[18] !== visible.length) {
    t9 = visible.length === 0 && <li className={styles.noResults}>Ingen biografer funnet for “{query}”</li>;
    $[17] = query;
    $[18] = visible.length;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <ul className={styles.cinemaList}>{t8}{t9}</ul>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== hasMore) {
    t11 = hasMore && <div style={{
      textAlign: "center"
    }}><button className={styles.showMoreButton} onClick={() => setExpanded(true)}>Se flere biografer<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg></button></div>;
    $[23] = hasMore;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t7) {
    t12 = <>{t7}{t10}{t11}</>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t7;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
}
function _temp(cinema) {
  return <Biograf key={cinema._id} cinema={cinema} />;
}